import { array, object, string } from "yup";

export const closingCustomChecklistSchema = object({
  other_actions: array().of(
    object({
      name: string().required("Name is required"),
    })
  ),
});
